class AuthController {
    constructor($state, djangoAuth, $scope) {
        this.username = '';
        this.password = '';
        this.$state = $state;
        this.$scope = $scope;
        this.djangoAuth = djangoAuth;
        this.djangoAuth.logout();
    }

    $onInit() {
        this.$scope.$watchCollection('[vm.username, vm.password]', (newVal, oldVal) => {
            this.logging = false;
            this.errors = false;
        });
    }

    login() {
        this.logging = true;
        this.errors = false;
        this.djangoAuth.login(this.username, this.password).then(
            data => {
                this.logging = false;
                this.$state.go('dashboard');
            },
            error => {
                this.logging = false;
                this.errors = error;
            }
        );
    }
}

AuthController.$inject = ['$state', 'djangoAuth', '$scope'];

export { AuthController };



// WEBPACK FOOTER //
// ./app/components/auth/auth.controller.js